import { TextOperation } from '../constants'

const initialState = ''

export function textReducer(state: string = initialState, operation: TextOperation) {
  switch (operation.type) {
    case 'insert':
      return state.slice(0, operation.start) + operation.text + state.slice(operation.start)
    case 'delete':
      return state.slice(0, operation.start) + state.slice(operation.start + operation.length)
  }
  return state
}
